import type { QuizsetCursorSearchReq } from '@/api/gen/_model/quizsetCursorSearchReq';
import { searchQuizLibrary } from '@/api/gen/quiz/quiz.gen';
import { followEmptyCursorPages } from '@/shared/utils/followEmptyCursorPages';

import type { LibraryItem } from '../types/library.types';

import { toLibraryItem } from './library.adapters';

export interface LibrarySearchPage {
  items: LibraryItem[];
  nextCursor?: string;
  hasNext: boolean;
  totalCount?: number;
}

export const searchLibrary = async (
  req: QuizsetCursorSearchReq,
  signal?: AbortSignal,
): Promise<LibrarySearchPage> => {
  const response = await followEmptyCursorPages(
    cursor => searchQuizLibrary({ ...req, cursor }, undefined, signal),
    req.cursor,
  );

  return {
    items: response.data.map(toLibraryItem),
    nextCursor: response.nextCursor,
    hasNext: response.hasNext,
    totalCount: response.totalCount,
  };
};
